import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-pedidos"
export default class extends Controller {
  static targets = ["internacionFields"]

  toggleFields(event) {
    const value = event.target.value

    if (value === "internacion") {
      this.internacionFieldsTarget.classList.remove("d-none")
    } else {
      // 🔥 Limpia todos los checkboxes dentro del div
      this.clearCheckboxes()

      // Oculta el bloque
      this.internacionFieldsTarget.classList.add("d-none")
    }
  }

  clearCheckboxes() {
    // Busca todos los inputs checkbox dentro del target
    const checkboxes = this.internacionFieldsTarget.querySelectorAll('input[type="checkbox"]')

    checkboxes.forEach(cb => cb.checked = false)
  }
}
